<template>
  <div class="detail">
    <div class="detail-head clear-fix">
      <div class="fl disFlex">
        <div class="flex1">
          <p class="font18">{{data.agentName}}</p>
          <p class="mt10">
            <span>登录名：{{data.userName}}</span>
            <span class="pl30">初始密码：{{data.password}}</span>
          </p>
        </div>
      </div>

      <div class="fr">
        <ul class="detail-head-content">
          <li>
            <p class="font22">{{data.userNum}}</p>
            <p>用户数</p>
          </li>
          <li>
            <p class="font22">{{data.accumulatedIncome}}</p>
            <p>累计收益</p>
          </li>
          <li>
            <p class="font22">{{data.accumulatedWithdrawal}}</p>
            <p>累计提现</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="detail-content">
      <p class="detail-content-title">基本信息</p>
      <el-row class="mb20">
        <el-col :span="6">负责人：{{data.realName}}</el-col>
        <el-col :span="6">手机号：{{data.phone}}</el-col>
        <el-col :span="6">代理区域：{{data.region}}</el-col>
        <el-col :span="6">代理商类型：{{data.userType}}</el-col>
      </el-row>
      <el-row class="mb20">
        <el-col :span="6">分成比例：{{data.proportion}}%</el-col>
        <el-col :span="6">状态：{{data.openFlag}}</el-col>
        <el-col :span="6">创建时间：{{data.createTime}}</el-col>
      </el-row>

      <p class="detail-content-title disFlex">
        <span class="flex1 text-left">广告分成（总收益：{{data.totalIncome}}元）</span>
        <span class="flex1 text-right font16 c-999">展示近3个月的收益明细</span>
      </p>
      <el-row class="mb20" v-for="(item, index) in data.adveDivideList" :key="index">
        <el-col :span="12">广告分成：{{item.adverDivideMoney}}元</el-col>
        <el-col :span="12">时间：{{item.adverDivideTime}}</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import {getAgentMsg} from '@/api'

  export default {
    props: ['id'],
    data () {
      return {
        data: {}
      }
    },
    created () {
      this.getAgentMsgFn()
    },
    watch: {
      id () {
        this.getAgentMsgFn()
      }
    },
    methods: {
      getAgentMsgFn () {
        getAgentMsg(this.id).then(res => {
          this.data = res.data
        })
      }
    }
  }
</script>

<style scoped>
  .detail {
    padding-bottom: 50px;
  }

  .detail-head {
    background-color: #ebeef5;
    padding: 20px 30px 20px 50px;
  }

  .detail-head-content > li {
    display: inline-block;
    text-align: center;
    margin-right: 40px;
    line-height: 30px;
  }

  .detail-content {
    padding: 0 50px;
  }

  .detail-content-title {
    font-size: 20px;
    font-weight: bold;
    padding-top: 30px;
    padding-bottom: 15px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
  }

  .production {
    border-bottom: 1px solid #ebeef5;
    padding: 5px;
  }

  .production-title {
    position: relative;
    display: inline-block;
    color: #000;
  }

  .production-title > span {
    position: absolute;
    right: -70px;
    top: 0;
    padding: 1px 10px;
    border: 1px solid #8b8d92;
    border-radius: 10px;
    font-size: 12px;
  }

  .production-time {
    color: rgb(148, 148, 148);
    font-size: 12px;
    line-height: 30px;
  }

  .production-imgs img {
    width: 150px;
    height: 100px;
    margin-right: 15px;
    margin-bottom: 10px;
  }
</style>
